import { EVENT, dispatchEvent } from "tools/events";
import { useViewerQuery } from "../viewerQuery";
import { FlagName } from "./userFlagsModel";

// return one of three states:
// 1. undefined: user is not in the test group
// 2. true: user is in the "on" test group
// 3. false: user is in the "off" test group

const AB_TEST_OVERRIDE_KEY = "abtest_override_enabled";

export const getABTestOverride = (): boolean | null => {
  try {
    const value = localStorage.getItem(AB_TEST_OVERRIDE_KEY);
    if (value === "true") return true;
    if (value === "false") return false;
    return null;
  } catch {
    return null;
  }
};

export const isABTestOverrideEnabled = (): boolean => {
  return getABTestOverride() !== null;
};

export const setABTestOverride = (enabled: boolean | null): void => {
  try {
    if (enabled === null) {
      localStorage.removeItem(AB_TEST_OVERRIDE_KEY);
    } else {
      localStorage.setItem(AB_TEST_OVERRIDE_KEY, enabled ? "true" : "false");
    }

    // Dispatch custom event to notify listeners
    dispatchEvent(EVENT.abtestOverrideChange);
  } catch {
    // localStorage not available
  }
};

export const useABTest = (testName: FlagName): boolean | undefined => {
  const { getFlag } = useViewerQuery();
  const abtest = getFlag(testName);

  // Check if override is set (for testing purposes)
  const override = getABTestOverride();
  if (override !== null) {
    return override;
  }

  return abtest ? abtest.value === "on" : undefined;
};
